const Xt = 'is-visible',
  Kt = 'meganav--visible',
  fS = 'a:not([href="#"]), button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

class ClickDisclosure extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');
    this.wrapper = this.closest('[data-header-wrapper]');
    this.key = this.getAttribute("aria-controls");
    this.grandparent = this.classList.contains("grandparent");
    this.disclosure = document.getElementById(this.key);
  }

  connectedCallback() {
    if (blockCustomerActions) return;

    this.addEventListener('click', (e) => !e.target.closest(".header__dropdown") && this.openDisclosure(e));
    this.addEventListener('keydown', (e) => (e.key.toUpperCase() === "ESCAPE") && this.hideDisclosure({ ...e, detail: { fromKeyboard: true } }));
    window.addEventListener('click', (e) => {
      if (!e.target || !e.target.nodeType) return;
      const close = e.target.classList.contains('header__dropdown__close') && e.target.getAttribute('aria-controls') === this.getAttribute("aria-controls");
      return (e.target !== this && !this.contains(e.target) || close) && this.hideDisclosure();
    });
    window.addEventListener('scroll', (e) => this.hideDisclosure());
    window.addEventListener("custom:click-disclosure:hide", (e) => this.hideDisclosure(e));
    this.querySelector('.header__dropdown').addEventListener('click', (e) => {
      if (e.target.tagName === "A" && e.target.getAttribute("href") !== "#") {
        GTM.trackMenuClick(
          e.target.textContent.trim(),
          e.target.closest('.dropdown__family').firstElementChild.textContent.trim(),
          this.link.textContent.trim()
        );
      }
    });
  }

  openDisclosure(e) {
    e.preventDefault();

    if (this.classList.contains(Xt)) {
      this.hideDisclosure({ ...e, detail: { fromKeyboard: e.pointerType === '' } });
      return;
    }

    const event = new CustomEvent('custom:click-disclosure:hide', {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail: { ignore: this, fromKeyboard: e.pointerType === '' }
    });

    window.dispatchEvent(event);

    this.grandparent ? this.wrapper.classList.add(Kt) : this.wrapper.classList.remove(Kt);
    this.disclosure.classList.add(Xt);

    this.classList.add(Xt);
    this.setAttribute('aria-expanded', 'true');

    if (e.pointerType === '') this.disclosure.querySelector(fS).focus();
  }

  hideDisclosure(e = null) {
    if (e?.detail?.ignore === this && !this.classList.contains(Xt)) return;

    this.classList.remove(Xt);
    this.disclosure.classList.remove(Xt);
    this.setAttribute('aria-expanded', 'false');
    this.wrapper.classList.remove(Kt);

    if (e?.detail?.fromKeyboard) this.link.focus();
  }
}

if (!customElements.get('click-disclosure')) customElements.define('click-disclosure', ClickDisclosure);